import * as React from 'react';
import { AlunoModel } from '../../../Store';
import { Card, CardTitle, CardContent, Input, Button, withGrid } from '../../../Components';
import styled from 'styled-components';
import { media } from '../../../Themes';


interface IDetalhesAlunoProps {
  aluno: AlunoModel,
  ativarOuDesativar: () => any;
}

const Grid = withGrid(CardContent);
const CardContentGrid = styled(Grid)`
  grid-template-columns: repeat(12, 1fr);
`;

const InputGrid = styled(Input) <any>`
  grid-column: ${p => p.gridColumn};
  margin: 0;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const ButtonGrid = styled(Button) <any>`
  max-width: fit-content;
  justify-self: flex-end;
  grid-column: ${p => p.gridColumn};

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const DetalhesAlunoCard: React.FC<IDetalhesAlunoProps> = ({ aluno, ativarOuDesativar }: IDetalhesAlunoProps) => {
  const [alunoAtivo, setAlunoAtivo] = React.useState(aluno.alunoAtivo);

  React.useEffect(() => {
    setAlunoAtivo(aluno.alunoAtivo)
  })

  return (
    <Card>
      <CardTitle>{aluno.nome}</CardTitle>
      <CardContentGrid>
        <InputGrid
          gridColumn='1/2'
          value={aluno.matricula}
          label='Matrícula'
          disabled={true}
        />
        <InputGrid
          gridColumn='2/6'
          value={aluno.email}
          label='Email'
          disabled={true}
        />
        <InputGrid
          gridColumn='6/8'
          value={`${aluno.serie} - ${aluno.turma}`}
          label='Série - Turma'
          disabled={true}
        />
        <ButtonGrid
          gridColumn='8/11'
          color={alunoAtivo ? 'errorColor' : 'approvedColor'}
          onClick={ativarOuDesativar}
        >
          {alunoAtivo ? 'DESATIVAR ALUNO' : 'ATIVAR ALUNO'}
        </ButtonGrid>
      </CardContentGrid>
    </Card>
  );
};

export default DetalhesAlunoCard;